module.exports = __webpack_public_path__ + "img/Weapon_88.3bd825bb.png";